import { AppId } from "@oneleet/config/constants";

export function logout({ appId }: { appId: AppId }) {
  window.location.href = `${import.meta.env.VITE_API_URL}/api/v1/users/logout/${appId}`;
}
